import { trackPromise } from "react-promise-tracker"
import { errorToast } from "../components/DommusToast"

export const cachearContexto = (chave, setStateChave, promise, loading=false, testeCacheContexto=null) => {
    if((testeCacheContexto == null && chave?.length) || testeCacheContexto) {
        return 0
    }
    if(loading) {
        trackPromise(promise()
            .then(response => setStateChave(response.data))
            .catch((error) => {
                console.log(error)
                console.log(error.response)
                errorToast.fire('Houve um erro ao tentar carregar dependencias.')
                
                return false
            })
        )
    } else {
        promise()
            .then(response => setStateChave(response.data))
            .catch((error) => {
                console.log(error)
                console.log(error.response)
                errorToast.fire('Houve um erro ao tentar carregar dependencias.')
                
                return false
            })
    }
    return 1
  
}
